<script setup>
import {ref} from 'vue'

const advertisementQuantity = ref(20)

// ceny za inzerát/den
const pricePerAdPerDayDiscount = 1.5   // po slevě
const pricePerAdPerDayOriginal = 2     // před slevou

const incrementQuantity = () => {
  advertisementQuantity.value += 1
}

const decrementQuantity = () => {
  if(advertisementQuantity.value > 1) {
    advertisementQuantity.value -= 1
  } else {
    advertisementQuantity.value = 1
  }
}

// měsíční cena po slevě
const calculatePricePerMonthsDiscount = (months) => {
  if(months < 1) return 0
  return Math.round(advertisementQuantity.value * pricePerAdPerDayDiscount * months * 30)
}

// měsíční cena bez slevy
const calculatePricePerMonthsOriginal = (months) => {
  if(months < 1) return 0
  return Math.round(advertisementQuantity.value * pricePerAdPerDayOriginal * months * 30)
}
</script>

<template>
  <div class="row g-2 justify-content-center">
    <!-- Počet vozů -->
    <div class="col-12">
      <div class="bg-white bg-opacity-10 p-2 p-lg-4 rounded-3 d-block d-lg-flex justify-content-between align-items-center text-white flex-wrap">
        <div>
          <h3 class="h2 fw-bold text-white mb-1">Počet inzerovaných vozů</h3>
          <p class="mb-0 fs-4 text-white">Zadejte váš průměrný počet inzerátů, který denně inzerujete.</p>
        </div>
        <div class="right d-flex justify-content-center align-items-center wrap-calc-input p-2 pb-0 p-lg-0">
          <button @click="decrementQuantity" class="btn btn-light text-danger btn-calc minus fw-bold fs-4 px-3">–</button>
          <input v-model="advertisementQuantity" id="carCount" type="number" class="form-control text-center fw-bold text-danger fs-4" min="1">
          <button @click="incrementQuantity" class="btn btn-light text-danger btn-calc plus fw-bold fs-4 px-3">+</button>
        </div>
      </div>
    </div>

    <!-- Náklady na inzerci -->
    <div class="col-12">
      <div class="bg-white bg-opacity-10 p-2 p-lg-4 rounded-3 d-block d-lg-flex justify-content-between align-items-center text-white flex-wrap">
        <div>
          <h3 class="h2 fw-bold text-white mb-1">Náklady na inzerci vozů</h3>
          <p class="mb-0 fs-4 text-white">Na základě počtu inzerátů vám spočítáme váší měsíční útratu.</p>
        </div>
        <div class="right text-center p-2 pb-0 p-lg-0">
          <div id="inzerceCostDiscount" class="h2 fw-bold text-white mb-0 mb-lg-1">
            {{ calculatePricePerMonthsDiscount(1) }} Kč
          </div>
          <p class="mb-0 fs-6 text-success">sleva 25% (1,50 Kč/den)</p>
          <div id="inzerceCostOriginal" class="h2 fw-bold line-th text-white mt-2 mb-0">
            {{ calculatePricePerMonthsOriginal(1) }} Kč
          </div>
          <p class="mb-0 fs-6 text-white-50">běžná cena (2 Kč/den)</p>
        </div>
      </div>
    </div>

    <!-- Výsledná částka -->
    <div class="col-12">
      <div class="bg-white p-2 p-lg-4 rounded-3 d-block d-lg-flex justify-content-between align-items-center flex-wrap">
        <div>
          <h3 class="h2 fw-bold mb-1">Orientační měsíční náklady</h3>
          <p class="mb-0 fs-4">Cena je závislá na přesném počtu vašich inzerátů za účtované období.</p>
        </div>
        <div class="right text-center p-2 pb-0 p-lg-0">
          <div id="totalCost" class="h2 fw-bold text-primary mb-0 mb-lg-1">
            {{ calculatePricePerMonthsDiscount(1) }} Kč
          </div>
          <div class="mb-0 fs-4">za měsíc (po slevě)</div>
        </div>
      </div>
    </div>
  </div>
</template>
